export const PREFIX = 'KENMEI'
export const CONST = (value) => (PREFIX + '_' + value)
export const SYSTEM_INIT = CONST('SYSTEM_INIT')
export const REDUCER_INIT = CONST('REDUCER_INIT')

export const systemInit = () => ({
  type: SYSTEM_INIT,
  payload: {
  }
})

export const reducerInit = (kenmeiCodes) => ({
  type: REDUCER_INIT,
  payload: {
    kenmeiCodes: kenmeiCodes,
  }
})



// WEBPACK FOOTER //
// ./src/actions/kenmei.js